export type ThemeColors = {
  success: {
    [x: string]: string;
  };
  warning: {
    [x: string]: string;
  };
  error: {
    [x: string]: string;
  };
  gray: {
    [x: string]: string;
  };
  red: {
    [x: string]: string;
  };
  darken: string;
  black: string;
  white: string;
  TEDRed: string;
};

export default {
  success: { 0: '#26a65b', 1: '#e0f2e8' },
  warning: { 0: '#e5af0a', 1: '#faf0cf' },
  error: { 0: '#d91e18', 1: '#ffeeef' },
  gray: {
    0: '#272727',
    1: '#3e3e3e',
    2: '#5e5d5d',
    3: '#7d7c7b',
    4: '#9c9b9a',
    5: '#bbbab9',
    6: '#dbd9d8',
    7: '#faf8f7',
  },
  red: {
    0: '#73150f',
    1: '#a11e15',
    2: '#cf261b',
    3: '#e62528',
    4: '#e94043',
    5: '#ed6a61',
    6: '#f5aaa5',
    7: '#fce9e8',
  },
  darken: 'rgba(31,31,31,0.25)',
  black: '#1b1f27',
  white: '#ffffff',
  TEDRed: '#e62b1e',
};
